import { useState } from 'react';
import Button from '../Button/Button';
import classNames from 'classnames';
import { iOS, isAndroid, isMobileDevice } from '../../core/helpers';
import DownloadWidget from '../DownloadWidget/DownloadWidget';
import { APPSTORE_URL, PLAYSTORE_URL } from '../../core/consts';
import { downloadApp } from '../DownloadWidget/DownloadWidget.helper';
import { ReactComponent as DownArrowIcon } from '../../icons/polygon.svg';
import './SmartDownloadAppButton.scss';

export const platformLinks: { [n: string]: string } = {
  ios: APPSTORE_URL,
  android: PLAYSTORE_URL
};

const SmartDownloadAppButton: React.FC = () => {
  const [isDisplayingStores, setIsDisplayingStores] = useState(false);

  const handleDownloadApp = () => {
    if (!isMobileDevice()) return setIsDisplayingStores(!isDisplayingStores);

    return downloadApp(iOS() ? 'ios' : isAndroid() ? 'android' : null);
  };

  return (
    <div className='SmartDownloadAppButton'>
      <Button
        className='SmartDownloadAppButton__button'
        variant='text'
        icon={<DownArrowIcon />}
        onClick={handleDownloadApp}
      >
        Download the App
      </Button>

      <div
        className={classNames('SmartDownloadAppButton__panel', {
          'SmartDownloadAppButton__panel--visible': isDisplayingStores
        })}
      >
        <DownloadWidget
          className='SmartDownloadAppButton__storesIcons'
          section='Header'
        />
      </div>
    </div>
  );
};

export default SmartDownloadAppButton;
